import { useRef } from "react";
import { FinancialApplicationFormSectionContextType, FinancialApplicationFormValidationDisplayBehavior, useFinancialApplicationFormSectionValidation } from "@/hooks/useFinancialApplicationFormSectionValidation";
import { TaskExecutionModuleFormProps } from "@bolt/task";
import { JointAccountOwnerIdentificationDocumentsForm } from "../JointAccountOwnerIdentificationDocumentsForm/JointAccountOwnerIdentificationDocumentsForm";
import { JointAccountOwnerForm } from "../JointAccountOwners/JointAccountOwnerForm";
import { useJointAccountOwner } from "@/hooks/useJointAccountOwner";
import { FieldFormV2Module, LoadingV2 } from "@ucl/library";
import { JointAccountOwner } from "@/types/JointAccountOwner";
import { FinancialApplicationSection } from "@/types/enums";
import "./JointAccountOwnerExpressionSchemaTaskExecutionTypeForm.scss";

export interface JointAccountOwnerExpressionSchemaTaskExecutionTypeFormProps
  extends TaskExecutionModuleFormProps {}

export const JointAccountOwnerExpressionSchemaTaskExecutionTypeForm: React.FC<
  JointAccountOwnerExpressionSchemaTaskExecutionTypeFormProps
> = (props) => {
  // Early return if required IDs are not available
  if (!props.parentEntityId || !props.entityId) {
    return <LoadingV2 />;
  }

  const fieldFormModule = useRef<FieldFormV2Module<JointAccountOwner> | null>(null);

  const {
    formValue,
    setFormValue,
    saveFormData,
    debitCardInformationRenderKey,
    digitalBankingInformationRenderKey,
  } = useJointAccountOwner(props.parentEntityId, props.entityId);

  const { getCollectionValidationErrors } = useFinancialApplicationFormSectionValidation(
    props.parentEntityId,
    FinancialApplicationSection.JointAccountOwners,
    FinancialApplicationFormValidationDisplayBehavior.AlwaysDisplayValidationErrors,
    FinancialApplicationFormSectionContextType.Task
  );

  const validationErrors = getCollectionValidationErrors("JointAccountOwners");

  if (!formValue) {
    return <LoadingV2 />;
  }

  return (
    <>
      <JointAccountOwnerForm
        fieldFormModule={fieldFormModule}
        formValue={formValue}
        setFormValue={setFormValue}
        saveFormData={saveFormData}
        debitCardInformationRenderKey={debitCardInformationRenderKey}
        digitalBankingInformationRenderKey={digitalBankingInformationRenderKey}
        validationErrors={
          validationErrors.fieldSchemaCollectionMemberValidationErrors[props.entityId] || {}
        }
        validationContextType={FinancialApplicationFormSectionContextType.Task}
        availableFields={props.availableFields}
        shouldShowDigitalBankingFields={true}
        shouldShowDebitCardFields={true}
      />
      <JointAccountOwnerIdentificationDocumentsForm
        jointOwnerId={props.entityId}
        availableFields={props.availableFields}
        autoValidationBehavior={
          FinancialApplicationFormValidationDisplayBehavior.AlwaysDisplayValidationErrors
        }
        showHeader={true}
        validationContextType={FinancialApplicationFormSectionContextType.Task}
        governmentIdType={formValue.governmentIdInformation?.governmentIdType}
      />
    </>
  );
};
